import React from "react";
import PropTypes from "prop-types";

/**
 * EmptyBlock:
 *    resnponsible for filling vaccant space in instruction block
 */
export function EmptyBlock(props) {
  return <div className={props.className} />;
}

EmptyBlock.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
};

EmptyBlock.defaultProps = {
  className: "",
};
